function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { companyURL } from '../endpoints';
import PromiseCache from '../utils/promise-cache';
import FetchWithAuth from '../utils/fetch-with-auth';

function CompanyService(authState) {
  var fetch = new FetchWithAuth(authState);
  var cache = new PromiseCache(authState);

  function listCompanies() {
    return _listCompanies.apply(this, arguments);
  }

  function _listCompanies() {
    _listCompanies = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return cache('listCompanies', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var res, _yield$res$json, data, errors;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return fetch("".concat(companyURL, "/graphql"), {
                          method: 'POST',
                          headers: {
                            'content-type': 'application/json'
                          },
                          body: JSON.stringify({
                            query: "\n                            query companyListQuery {\n                                companyList {\n                                    id\n                                    name\n                                }\n                            }\n                        ",
                            variables: {}
                          })
                        });

                      case 2:
                        res = _context.sent;
                        _context.next = 5;
                        return res.json();

                      case 5:
                        _yield$res$json = _context.sent;
                        data = _yield$res$json.data;
                        errors = _yield$res$json.errors;

                        if (!errors) {
                          _context.next = 10;
                          break;
                        }

                        throw new Error(errors.map(function (e) {
                          return e.message;
                        }).join('\n'));

                      case 10:
                        return _context.abrupt("return", data.companyList.sort(function (a, b) {
                          return a.name.localeCompare(b.name, undefined, {
                            'sensitivity': 'base'
                          });
                        }));

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })))();

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _listCompanies.apply(this, arguments);
  }

  function getCompany(_x) {
    return _getCompany.apply(this, arguments);
  }

  function _getCompany() {
    _getCompany = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(companyId) {
      var companies;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return listCompanies();

            case 2:
              companies = _context3.sent;
              return _context3.abrupt("return", companies.find(function (c) {
                return c.id === companyId;
              }));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _getCompany.apply(this, arguments);
  }

  function listCountries(_x2) {
    return _listCountries.apply(this, arguments);
  }

  function _listCountries() {
    _listCountries = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(companyId) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return cache("listCountries:".concat(companyId), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var res, _yield$res$json2, data, errors;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return fetch("".concat(companyURL, "/graphql"), {
                          method: 'POST',
                          headers: {
                            'content-type': 'application/json'
                          },
                          body: JSON.stringify({
                            query: "\n                            query companyQuery($companyId: String!) {\n                                company(id: $companyId) {\n                                    countryList {\n                                        name\n                                        iso2Code\n                                        iso3Code\n                                        active\n                                    }\n                                }\n                            }",
                            variables: {
                              companyId: companyId
                            }
                          })
                        });

                      case 2:
                        res = _context4.sent;
                        _context4.next = 5;
                        return res.json();

                      case 5:
                        _yield$res$json2 = _context4.sent;
                        data = _yield$res$json2.data;
                        errors = _yield$res$json2.errors;

                        if (!errors) {
                          _context4.next = 10;
                          break;
                        }

                        throw new Error(errors.map(function (e) {
                          return e.message;
                        }).join('\n'));

                      case 10:
                        return _context4.abrupt("return", data.company.countryList.sort(function (a, b) {
                          return a.name.localeCompare(b.name, undefined, {
                            'sensitivity': 'base'
                          });
                        }));

                      case 11:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              })))();

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _listCountries.apply(this, arguments);
  }

  return {
    listCompanies: listCompanies,
    getCompany: getCompany,
    listCountries: listCountries
  };
}

export default CompanyService;
//# sourceMappingURL=company.js.map